module.exports = __webpack_public_path__ + "img/sercure.f12bc0bf.jpg";